import { Component } from '@angular/core';
import { Platform, App } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AnalyticsProvider } from '../providers/analytics/analytics';

import { TabsPage } from '../pages/tabs/tabs';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  // @ViewChild('myNav') nav: NavController
  public rootPage:any = TabsPage;
  tabsPlacement: string = 'bottom';
  tabsLayout: string = 'icon-top';

  constructor(myApp: App, platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, public analyticsProvider: AnalyticsProvider) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      if (platform.is('cordova')) {
        statusBar.styleDefault();
        splashScreen.hide();
      }
    });

    // Google Analytics
    // console.log('Initializing Analytics');
    this.analyticsProvider.startTrackerWithId('UA-85728484-2');
    myApp.viewDidEnter.subscribe(
      (view) => {
        if ((view.instance.constructor.name !== 'TabsPage') && (view.instance.constructor.name !== 'ToastCmp') && (view.instance.constructor.name !== 'StationSelectPage')) {
          this.analyticsProvider.trackView(view.id, view.instance.title);
          // console.log('Id: ' + view.id);
          // console.log('Title: ' + view.instance.title);
          // console.log('page: ' + view._nav._linker._history.slice(-1)[0]);
          // console.log('page: ' + view._nav._linker._location._platformStrategy._platformLocation.location.hash);
          // console.log('View: ' + view.instance.constructor.name, view);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts